/**
 * COPYRIGHT NOTICE
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in the
 * "LICENSE.txt" file, which is part of this source code package.
 */
import {
	Button,
	Column,
	Icon,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import getIsMobile from '../OneHat/functions/getIsMobile';
import ScreenContainer from '../OneHat/components/ScreenContainer';
import testProps from '../OneHat/functions/testProps';
import withRedux from '../OneHat/data/hoc/withRedux';
import LoopIcon from '../components/Icons/LoopIcon';
import MouthIcon from '../components/Icons/MouthIcon';
import PresentationIcon from '../components/Icons/PresentationIcon';
import _ from 'lodash';


function Setup(props) {
	const {
			audioIsLooping,
			audioIsKaraokeMode,
			audioIsAutoAdvance,
			audioIsLyricsMode,
			showQuestionsInDivisions,
			actions,
		} = props,
		isMobile = getIsMobile(),
		toggleIsLooping = () => {
			actions.toggleIsLooping();
		},
		toggleIsLyricsMode = () => {
			actions.toggleIsLyricsMode();
		},
		toggleIsAutoAdvance = () => {
			actions.toggleIsAutoAdvance();
		},
		toggleIsKaraokeMode = () => {
			actions.toggleIsKaraokeMode();
		},
		toggleShowQuestionsInDivisions = () => {
			actions.toggleShowQuestionsInDivisions();
		};

	const
		buttonProps = {
			bg: 'trueGray.200',
			mb: 2,
			borderBottomColor: 'trueGray.400',
			borderBottomWidth: 1,
		},
		iconProps = {
			alignSelf: 'center',
			size: 'sm',
			px: 0,
		};


	return <ScreenContainer screenName="Setup">
			
				<Column w="100%" p={10}>
					<Button
						{...testProps('karaokeBtn')}
						{...buttonProps}
						leftIcon={<MouthIcon {...iconProps} color={!audioIsKaraokeMode ? '#fff' : 'trueGray.800'} />}
						onPress={toggleIsKaraokeMode}
						_text={{
							color: !audioIsKaraokeMode ? '#fff' : 'trueGray.800',
						}}
						bg={!audioIsKaraokeMode ? 'primary.600' : 'trueGray.200'}
					>{'Voices ' + (!audioIsKaraokeMode ? 'On' : 'Off')}</Button>
					<Button
						{...testProps('lyricsBtn')}
						{...buttonProps}
						leftIcon={<PresentationIcon {...iconProps} color={audioIsLyricsMode ? '#fff' : 'trueGray.800'} />}
						onPress={toggleIsLyricsMode}
						_text={{
							color: audioIsLyricsMode ? '#fff' : 'trueGray.800',
						}}
						bg={audioIsLyricsMode ? 'primary.600' : 'trueGray.200'}
					>{'Animated Lyrics ' + (audioIsLyricsMode ? 'On' : 'Off')}</Button>
					<Button
						{...testProps('loopBtn')}
						{...buttonProps}
						leftIcon={<LoopIcon {...iconProps} color={audioIsLooping ? '#fff' : 'trueGray.800'} />}
						onPress={toggleIsLooping}
						_text={{
							color: audioIsLooping ? '#fff' : 'trueGray.800',
						}}
						bg={audioIsLooping ? 'primary.600' : 'trueGray.200'}
						>{'Looping ' + (audioIsLooping ? 'On' : 'Off')}</Button>
					<Button
						{...testProps('autoAdvanceBtn')}
						{...buttonProps}
						leftIcon={<Icon as={FontAwesome5} {...iconProps} name="share" color={audioIsAutoAdvance ? '#fff' : 'trueGray.800'} />}
						onPress={toggleIsAutoAdvance}
						_text={{
							color: audioIsAutoAdvance ? '#fff' : 'trueGray.800',
						}}
						bg={audioIsAutoAdvance ? 'primary.600' : 'trueGray.200'}
					>{'Auto-Advance ' + (audioIsAutoAdvance ? 'On' : 'Off')}</Button>
					{isMobile && <Button
									{...testProps('questionsInDivisionBtn')}
									{...buttonProps}
									leftIcon={<Icon as={FontAwesome5} {...iconProps} name="list" color={showQuestionsInDivisions ? '#fff' : 'trueGray.800'} />}
									onPress={toggleShowQuestionsInDivisions}
									_text={{
										color: showQuestionsInDivisions ? '#fff' : 'trueGray.800',
									}}
									bg={showQuestionsInDivisions ? 'primary.600' : 'trueGray.200'}
								>{'Questions in Divisions ' + (showQuestionsInDivisions ? 'On' : 'Off')}</Button>}
				</Column>
			
			</ScreenContainer>;
}

export default withRedux(Setup, [
	'audioIsLooping',
	'audioIsKaraokeMode',
	'audioIsAutoAdvance',
	'audioIsLyricsMode',
	'showQuestionsInDivisions',
]);